var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 3.85H15.7983C15.9807 3.85 16.1547 3.92664 16.2779 4.06121L17.5132 5.41133C17.769 5.69082 18.1304 5.85 18.5092 5.85H21.2388C22.1455 5.85 22.8888 6.5933 22.8888 7.5V19.5C22.8888 20.4067 22.1455 21.15 21.2388 21.15H5.23877C4.33207 21.15 3.58877 20.4067 3.58877 19.5V7.5C3.58877 6.5933 4.33207 5.85 5.23877 5.85H7.96833C8.34717 5.85 8.70857 5.69082 8.96431 5.41133L10.1997 4.06121C10.3228 3.92664 10.4968 3.85 10.6792 3.85Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55557 13.3476C8.55557 10.7626 10.6537 8.66445 13.2387 8.66445C15.8237 8.66445 17.9219 10.7626 17.9219 13.3476C17.9219 15.9326 15.8237 18.0308 13.2387 18.0308C10.6537 18.0308 8.55557 15.9326 8.55557 13.3476Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2626 13.3473C10.2626 11.7047 11.5958 10.3715 13.2384 10.3715C14.8809 10.3715 16.2142 11.7047 16.2142 13.3473C16.2142 14.9898 14.8809 16.3231 13.2384 16.3231C11.5958 16.3231 10.2626 14.9898 10.2626 13.3473Z",
    fill: "#00C65E",
    stroke: "#00C65E",
    strokeWidth: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/icon6.267a7088021f8006d8f89beab823a953.svg";
export { ForwardRef as ReactComponent };